import { render } from "./HeroiconsOutlineSparkles.vue?vue&type=template&id=7094f7d4"
const script = {}

import exportComponent from "/Users/dorinpuscasu/Desktop/Projects/linella/linella-backend/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineSparkles.vue"]])

export default __exports__